import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  class: "modal fade",
  ref: "uploadModalcardStatusRef",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload_card_status"
}
const _hoisted_3 = { class: "modal-dialog mw-700px" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Upload Status Cetak Kartu ", -1)
const _hoisted_7 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2x" }
const _hoisted_9 = { class: "modal-body row pt-1" }
const _hoisted_10 = { class: "row mt-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pilih File")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container px-2 mt-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("hr", {
      style: {"width":"100%"},
      size: "5",
      color: "black"
    })
  ])
], -1)
const _hoisted_15 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_16 = {
  key: 0,
  style: {"margin-right":"230px"},
  id: "myDropdownDownload",
  class: "dropdown-content2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-warning",
  style: {"cursor":"pointer"},
  href: "/superadmin/card-design/history-upload-card-status"
}, " History Upload Cetak ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary me-3",
      "data-bs-toggle": "modal",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.callModal()))
    }, " Update Status Cetak Kartu "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_form_item, { prop: "file" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("input", {
                    name: "file",
                    accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    type: "file",
                    id: "file",
                    class: "form-control form-control-lg",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFileUpload($event))),
                    key: _ctx.items.fileInputKey
                  }, null, 32))
                ]),
                _: 1
              }),
              (_ctx.targetData.file == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.items.errorfile), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadDropdown()))
            }, " Download Template "),
            (_ctx.showDropdownBtnHDownload == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("a", {
                    style: {"text-align":"left"},
                    class: "btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.templateExcel()))
                  }, "Download Template Data Kosong"),
                  _createElementVNode("a", {
                    style: {"text-align":"left"},
                    class: "btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadAllStudent()))
                  }, "Download Template Data Siswa Semua"),
                  _createElementVNode("a", {
                    style: {"text-align":"left"},
                    class: "btn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadIsPrint(true)))
                  }, "Download Template Data Siswa Tercetak"),
                  _createElementVNode("a", {
                    style: {"text-align":"left"},
                    class: "btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadIsPrint(false)))
                  }, "Download Template Data Siswa Belum Tercetak")
                ]))
              : _createCommentVNode("", true),
            _hoisted_17,
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-success",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submit()))
            }, " Upload Data "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              "data-bs-dismiss": "modal",
              onClick: _cache[8] || (_cache[8] = 
              () => {
                (_ctx.targetData.file = ''),
                  (_ctx.targetData.fileName = ''),
                  _ctx.items.fileInputKey++;
              }
            )
            }, " Batal ")
          ])
        ])
      ])
    ], 512)
  ], 64))
}